module.exports = __webpack_public_path__ + "img/download-icon.ffd0d644.svg";